import BaseService from '../../services/BaseService';

class ReadStatusService extends BaseService{

}

export default new ReadStatusService('health_backend','health/read_status');